import { render } from "./ReplyToEmailConfigContainer.vue?vue&type=template&id=27c09c36"
import script from "./ReplyToEmailConfigContainer.vue?vue&type=script&lang=js"
export * from "./ReplyToEmailConfigContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__